import $ from 'jquery';
import React, {Component, ReactNode} from 'react';
import I18n from 'app/i18n';
import {scrollToTop, time, userSignedIn, isGuest, getImageDomain} from 'app/utils';
import {showSendForm, showSwapForm} from '../promo_action/gift';
import {goToRoute} from 'app/utils/link_helper';
import {showBetForm} from 'app/components/table';
import {hideChatActions, rowColor} from 'app/components/chat/chat_utils';
import {showUserMutePopup} from 'app/components/chat/UserMutePopup';
import {showUserBanPopup} from 'app/components/chat/user_ban_popup';
import {goToLinkMarketplace, goToShopLootbox, goToCasino} from 'app/utils/app_links';
import {startCasinoGame} from 'app/services/CasinoServices';
import {inject, observer} from 'mobx-react';
import {MessageInterface} from 'app/interfaces/stores/chat/MessageInterface';
import {ChatStore} from 'app/store/ChatStore';
import {promoActionStore, userStore} from 'app/store/global';
import SpriteIcon from 'app/utils/sprites/SpriteIcon';
import {isNewDesktop} from 'app/utils/windowFunctions';

const ADMIN = 1;
const MODERATOR = 2;
const USER = 11;
const MODERATORS_GROUPS = [
    ADMIN,
    MODERATOR,
    USER
];

const NOT_FOUND_INDEX = -1;

const IMAGE_SRC_REGEX = /src="(?:(?:https:\/\/[^/]+)?\/)?(?:images\/)?(?<path>(?:smiles|recipes|skins)\/[^"]*)"/gu;

interface Props {
    chatStore?: ChatStore,
    giftsEnabled: boolean,
    insertUserName: (id: number, name: string, message: string) => void,
    insertUserNameNick: (name: string) => void,
    message: MessageInterface,
    deactivateMessageReply?: () => void,
    setActiveMessageReply?: (id: number) => void,
    showMessageReply?: boolean
    clearReply?: () => void
}

@inject('chatStore')
@observer
export default class ChatMessage extends Component<Props> {
    messageContent: React.RefObject<HTMLDivElement> = React.createRef();

    componentDidMount(): void {
        this.clickOnBetFromChat($('.open-chat-bet', this.messageContent.current));
        this.clickOnLootboxFromChat($('.open-shop-lootboxes', this.messageContent.current));
        this.clickOnMarketplaceFromChat($('.open-shop-marketplace', this.messageContent.current));
        this.clickOnCasinoGameFromChat($('.open-casino-game', this.messageContent.current));
    }

    clickOnBetFromChat = (chatBet: HTMLFormElement): void => {
        chatBet.on('click', this.clickBetLinkHandler);
    };

    clickOnLootboxFromChat = (chatLootbox: HTMLFormElement): void => {
        chatLootbox.on('click', this.clickLootboxLinkHandler);
    };

    clickOnMarketplaceFromChat = (chatMarketplace: HTMLFormElement): void => {
        chatMarketplace.on('click', this.clickMarketplaceLinkHandler);
    };

    clickOnCasinoGameFromChat = (chatCasinoGame: HTMLFormElement): void => {
        chatCasinoGame.on('click', this.clickCasinoGameLinkHandler);
    };

    clickBetLinkHandler(): void {
        scrollToTop();
        const data = $(this).data();
        showBetForm({hash_id: data.hashId}, data.on, {openBetSlip: true});
    }

    clickLootboxLinkHandler(e: React.MouseEvent): void {
        e.preventDefault();
        goToShopLootbox($(this).data().slug);
        scrollToTop();
    }

    clickMarketplaceLinkHandler(e: React.MouseEvent): void {
        e.preventDefault();
        goToLinkMarketplace($(this).data());
        scrollToTop();
    }

    clickCasinoGameLinkHandler(e: React.MouseEvent): void {
        e.preventDefault();
        goToCasino();
        startCasinoGame($(this).data('id'));
        scrollToTop();
    }

    canMute = (): boolean => userSignedIn() &&
        userStore.user.id !== this.props.message.uid &&
        this.props.message.uid !== 0 &&
        MODERATORS_GROUPS.indexOf(this.props.message.ug) === NOT_FOUND_INDEX &&
        MODERATORS_GROUPS.indexOf(userStore.user.group) === NOT_FOUND_INDEX;

    canDelete = (): boolean => userStore.user.id === this.props.message.uid ||
        MODERATORS_GROUPS.indexOf(userStore.user.group) > NOT_FOUND_INDEX;

    canBan = (): boolean => userSignedIn() &&
        MODERATORS_GROUPS.indexOf(userStore.user.group) > NOT_FOUND_INDEX &&
        MODERATORS_GROUPS.indexOf(this.props.message.ug) === NOT_FOUND_INDEX;

    hasActions = (): boolean => this.canDelete() || this.canMute() || this.canBan();

    canGift = (): boolean => this.props.giftsEnabled && (this.canMute() || this.canBan());

    isModeratorMessage = (): boolean => MODERATORS_GROUPS.indexOf(this.props.message.ug) !== NOT_FOUND_INDEX;

    publicInventory = (): void => {
        goToRoute(`/profile/${this.props.message.un}`);
        hideChatActions();
        scrollToTop();
    };

    offerTrade = (): void => {
        goToRoute(`/profile/${this.props.message.un}/trade`);
        hideChatActions();
        scrollToTop();
    };

    handleDeleteMessage = (e: React.MouseEvent): void => {
        e.preventDefault();
        this.props.chatStore.deleteMessage(this.props.message.id);
    };

    handleShowUserBanPopup = (e: React.MouseEvent): void => {
        e.preventDefault();
        const {uid, un} = this.props.message;
        showUserBanPopup(uid, un);
    };

    handleShowUserMutePopup = (e: React.MouseEvent): void => {
        e.preventDefault();
        const {uid, un} = this.props.message;
        showUserMutePopup(uid, un, this.props.chatStore);
    };

    handleInsertUserName = (e: React.MouseEvent): void => {
        e.preventDefault();
        const {insertUserName, message: {id, un, m}} = this.props;
        insertUserName(id, un, m);
    };

    handleInsertUserNameNick = (e: React.MouseEvent): void => {
        e.preventDefault();
        this.props.insertUserNameNick(this.props.message.un);
    };

    handleGiftShowForm = (e: React.MouseEvent): void => {
        e.preventDefault();
        showSendForm(this.props.message.un, promoActionStore.promoActions.PromoActionPresent.to_send);
    };

    handleGiftSwapForm = (e: React.MouseEvent): void => {
        e.preventDefault();
        showSwapForm(this.props.message.un);
    };

    mobileOpenReply = (): void => {
        if (!isNewDesktop()) {
            this.props.setActiveMessageReply(this.props.message.id);
        }
    };

    render(): ReactNode {
        const {ca, un, ug, uid} = this.props.message;

        return <div className="chat__message" onClick={this.mobileOpenReply}>
            <span className="chat__message-info">
                <span className="chat__message-time">{time(ca)}</span>
                {this.hasActions() && <span className="chat__actions">
                    <span className="chat__actions-toggle">
                        <SpriteIcon name="#svg-arr-down" size={{height: 12, width: 10}}/>
                    </span>
                    <div className="chat__actions-list">
                        {this.canBan() && <div
                            className="chat__actions-item"
                            onClick={this.handleShowUserBanPopup}
                        >
                            <SpriteIcon className="svg-default" name="#svg-chat-ban"/>
                            <span className="chat__actions-item-name" title="Ban user">Ban</span>
                        </div>}
                        {this.canMute() && <div
                            className="chat__actions-item"
                            onClick={this.handleShowUserMutePopup}
                        >
                            <SpriteIcon className="svg-default" name="#svg-chat-user-mute"/>
                            <span className="chat__actions-item-name" title={I18n.t('user.mute')}>{I18n.t('user.mute')}</span>
                        </div>}
                        {!this.isModeratorMessage() && <div
                            className="chat__actions-item"
                            onClick={this.publicInventory}
                        >
                            <SpriteIcon className="svg-default" name="#svg-chat-inventory"/>
                            <span className="chat__actions-item-name" title={I18n.t('inventory')}>{I18n.t('inventory')}</span>
                        </div>}
                        {this.canDelete() && <div
                            className="chat__actions-item"
                            onClick={this.handleDeleteMessage}
                        >
                            <SpriteIcon className="svg-default" name="#svg-chat-user-delete"/>
                            <span className="chat__actions-item-name" title={I18n.t('user.delete')}>{I18n.t('user.delete')}</span>
                        </div>}
                        {this.canGift() && <div
                            className="chat__actions-item"
                            onClick={this.handleGiftShowForm}
                        >
                            <SpriteIcon className="svg-default" name="#svg-chat-send-gift"/>
                            <span className="chat__actions-item-name"
                                title={I18n.t('user.promo_action.send_gift')}>{I18n.t('user.promo_action.send_gift')}</span>
                        </div>}
                        {this.canGift() && <div
                            className="chat__actions-item"
                            onClick={this.handleGiftSwapForm}
                        >
                            <SpriteIcon className="svg-default" name="#svg-chat-swap-gift"/>
                            <span className="chat__actions-item-name"
                                title={I18n.t('user.promo_action.swap_gift')}>{I18n.t('user.promo_action.swap_gift')}</span>
                        </div>}
                        {!this.isModeratorMessage() && <div className="chat__actions-item" onClick={this.offerTrade}>
                            <SpriteIcon className="svg-default" name="#svg-chat-offer-trade"/>
                            <span className="chat__actions-item-name" title={I18n.t('offer_trade')}>{I18n.t('offer_trade')}</span>
                        </div>}
                    </div>
                </span>}

                <a href="#" className={`chat__message-nickname ${rowColor(ug, uid)}`}
                    style={{color: this.props.message.name_color}}
                    onClick={this.handleInsertUserNameNick}>{un}</a>
            </span>
            <div className="chat__message-text" ref={this.messageContent}
                dangerouslySetInnerHTML={{
                    __html: this.props.message.m.replace(IMAGE_SRC_REGEX, `src="${getImageDomain()}/$<path>"`)
                }}/>
            {!isGuest() && <button
                id="id_button_reply"
                className={`chat__button-reply${this.props.showMessageReply ? ' active' : ''}`}
                onClick={this.handleInsertUserName}>
                <SpriteIcon
                    id="id_svg_use_button_reply"
                    idSvg="id_svg_button_reply"
                    className="svg-default"
                    name="#svg-chat-reply"/>
            </button>}
        </div>;
    }
}
